<template>
    <!-- Theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <BauDoTesouroViewOne :data-set="dataSet" @go-to-share="goToShare" @go-to-user-details="goToUserDetails" />
    </div>
    <!-- Theme two -->
    <div v-if="themeStore.themeIndex === 2">
        <BauDoTesouroViewTwo :data-set="dataSet" @go-to-share="goToShare" @go-to-user-details="goToUserDetails" />
    </div>
    <div v-if="themeStore.themeIndex === 3">
        <BauDoTesouroViewThree :data-set="dataSet" @go-to-share="goToShare" @go-to-user-details="goToUserDetails" />
    </div>
    <div v-if="themeStore.themeIndex === 4">
        <BauDoTesouroViewFour :data-set="dataSet" @go-to-share="goToShare" @go-to-user-details="goToUserDetails" />
    </div>
    <StatusPopup :content="$t('common.loading')" :isLoading="true" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { useRouter } from 'vue-router';
import { useTreasureActivityStore } from '@/stores/treasure';
import { getActivityInformations } from '@/api/common';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { Share } from '@capacitor/share';
import BauDoTesouroViewOne from '@/themes/themeOne/bauDoTesouro/bauDoTesouroView.vue';
import BauDoTesouroViewTwo from '@/themes/themeTwo/bauDoTesouro/bauDoTesouroView.vue';
import BauDoTesouroViewThree from '@/themes/themeThree/bauDoTesouro/bauDoTesouroView.vue';
import BauDoTesouroViewFour from '@/themes/themeFour/bauDoTesouro/bauDoTesouroView.vue';
import { InfoConfig, TreasureData } from './supportScript';
import { useThemeStore } from '@/stores/theme';

const activityStore = useTreasureActivityStore()
const router = useRouter()
const themeStore = useThemeStore()

const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const descriptionHtml = ref([])
const activityConfig = ref<InfoConfig>({
    equipment_limit: '',
    ip_limit: '',
    recharge_require: '',
    turnover_require: '',
    turnover_require_times: '',
    valid_user_count: 0,
    link: '',
    reward_conf: []
})
const bannerIcon = ref('')

const dataSet = computed<TreasureData>(() => ({
    descriptionHtml: descriptionHtml.value,
    activityConfig: activityConfig.value,
    bannerIcon: bannerIcon.value
}))

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}

const getActivityInfo = () => {
    loadingRef.value.open()
    let data = {
        activityId: "user_referral_reward"
    }

    getActivityInformations(data).then(res => {
        loadingRef.value.close()
        const resData = res.data
        bannerIcon.value = resData?.floatIcon
        descriptionHtml.value = JSON.parse(resData.activityIntro)
        activityConfig.value = resData.config
        activityStore.setActivityData(resData.config.recharge_require, resData.config.turnover_require, resData.config.ip_limit)
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}
const goToShare = async () => {
    let shareLink = activityConfig.value?.link //localStorage.getItem('shareLink')
    try {
      if (!shareLink) { return }
        await Share.share({
            text: shareLink,
        });
    } catch (error) {
       console.warn('Not supporting') 
    }
}

const goToUserDetails = async () => {
   router.push('/sdagusers')
}
onMounted(() => {
    getActivityInfo()
})

</script>